import classNames from 'classnames';
import { omit } from 'lodash/fp';
import * as React from 'react';
import { EventTrackingProps } from '../../services/Tracking';
import Button, { ButtonKind, KINDS_CLASSMAP } from '../Button';
import Link from '../Link';

const linkOnlyProps = [
    'download',
    'href',
    'hrefLang',
    'media',
    'ping',
    'rel',
    'target',
    'type',
    'referrerPolicy',
] as const;

const omitLinkProps = (linkProps: React.AnchorHTMLAttributes<HTMLAnchorElement>) =>
    omit(linkOnlyProps, linkProps) as React.ButtonHTMLAttributes<HTMLButtonElement>;

type LinkButtonProps = {
    href: string;
    kind?: ButtonKind;
    isSmall?: boolean;
    className?: string;
    disabled?: boolean;
    eventTracking?: EventTrackingProps;
    testId?: string;
    openInNewTab?: boolean;
    openInModal?: boolean;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export default function LinkButton({
    href,
    kind = 'DEFAULT',
    isSmall = false,
    className,
    disabled = false,
    eventTracking,
    openInNewTab,
    openInModal,
    ...passedProps
}: LinkButtonProps) {
    if (disabled) {
        return (
            <Button {...omitLinkProps(passedProps)} kind={kind} className={className} isSmall={isSmall} disabled>
                {passedProps.children}
            </Button>
        );
    }

    const cN = classNames({ small: isSmall }, KINDS_CLASSMAP[kind], className);
    return (
        <Link
            href={href}
            {...passedProps}
            openInNewTab={openInNewTab}
            openInModal={openInModal}
            eventTracking={eventTracking}
            className={cN}
        />
    );
}
